import moment from 'moment'
import {
  BUSINESS_HOURS_LOAD_REQUEST,
  BUSINESS_HOURS_LOAD_RESPONSE,
  BUSINESS_HOURS_LOAD_ERROR,
  BUSINESS_HOURS_SAVE_REQUEST,
  BUSINESS_HOURS_SAVE_RESPONSE,
  BUSINESS_HOURS_SAVE_ERROR,
  BUSINESS_HOURS_DAY_ENABLED_CHANGE,
  BUSINESS_HOURS_TIME_CHANGE,
  BUSINESS_HOURS_TIMEZONE_CHANGE,
} from './types'
import { parseBusinessHours } from './util'

const defaultBusinessHoursState = {
  days: {
    1: { start: '09:00 AM', end: '05:00 PM' },
    2: { start: '09:00 AM', end: '05:00 PM' },
    3: { start: '09:00 AM', end: '05:00 PM' },
    4: { start: '09:00 AM', end: '05:00 PM' },
    5: { start: '09:00 AM', end: '05:00 PM' },
    6: { start: '09:00 AM', end: '05:00 PM' },
    7: { start: '09:00 AM', end: '05:00 PM' },
  },
  loadErrored: false,
  loaded: false,
  loading: false,
  saveErrored: false,
  saved: false,
  saving: false,
}

export default function businessHours(
  state,
  {
    type,
    payload: { dayNumber, day: { end, start } = {}, result, timezone } = {},
  }
) {
  if (type === BUSINESS_HOURS_LOAD_REQUEST) {
    return {
      ...state,
      loadErrored: false,
      loaded: false,
      loading: true,
    }
  } else if (type === BUSINESS_HOURS_LOAD_RESPONSE) {
    return {
      ...state,
      loadErrored: false,
      loading: false,
      loaded: true,
      days: parseBusinessHours(result.days),
      timezone: result.timezone,
      persisted: true,
    }
  } else if (type === BUSINESS_HOURS_LOAD_ERROR) {
    return {
      ...state,
      loadErrored: true,
      loading: false,
    }
  } else if (type === BUSINESS_HOURS_SAVE_REQUEST) {
    return {
      ...state,
      saveErrored: false,
      saved: false,
      saving: true,
    }
  } else if (type === BUSINESS_HOURS_SAVE_RESPONSE) {
    return {
      ...state,
      saveErrored: false,
      saving: false,
      saved: true,
      days: parseBusinessHours(result.days),
      persisted: true,
    }
  } else if (type === BUSINESS_HOURS_SAVE_ERROR) {
    return {
      ...state,
      saveErrored: true,
      saving: false,
    }
  } else if (type === BUSINESS_HOURS_DAY_ENABLED_CHANGE) {
    return {
      ...state,
      days: {
        ...state.days,
        [dayNumber]: {
          ...state.days[dayNumber],
          enabled: !state.days[dayNumber].enabled,
        },
      },
      persisted: false,
    }
  } else if (type === BUSINESS_HOURS_TIME_CHANGE) {
    const newDay = {}
    if (start) newDay.start = start
    if (end) newDay.end = end
    const existingEnd = state.days[dayNumber].end
    if (existingEnd && start) {
      const endMoment = moment(existingEnd, 'hh:mm A')
      const startMoment = moment(start, 'hh:mm A')
      const isEndBeforeStart =
        existingEnd !== '12:00 AM' && endMoment.diff(startMoment) < 0
      if (isEndBeforeStart) {
        newDay.end = moment(startMoment)
          .add(30, 'minutes')
          .format('hh:mm A')
      }
    }

    return {
      ...state,
      days: {
        ...state.days,
        [dayNumber]: {
          ...state.days[dayNumber],
          ...newDay,
        },
      },
      persisted: false,
    }
  } else if (type === BUSINESS_HOURS_TIMEZONE_CHANGE) {
    return {
      ...state,
      timezone,
    }
  }
  return state || defaultBusinessHoursState
}
